import PropTypes from "prop-types";
import { Controller, useFormContext } from "react-hook-form";
import SixDigitCodeInput from "../shared/SixDigitCodeInput";

const VerificationCodeField = ({ name, label = "6-Digit Code", disabled, ...rest }) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <SixDigitCodeInput
          value={field.value || ""}
          onChange={field.onChange}
          label={label}
          disabled={!!disabled}
          error={!!fieldState.error}
          helperText={fieldState.error?.message}
          {...rest}
        />
      )}
    />
  );
};

VerificationCodeField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  disabled: PropTypes.bool,
};

export default VerificationCodeField;
